import {
    PHONE_NUMBER_CHANGED,
    PASSWORD_CHANGED,
    REFERRAL_CODE_CHANGED,
    COUNTRY_CODE_CHANGED,
    SIGNUP_REQUEST,
    SIGNUP_REQUEST_SUCCESS,
    SIGNIN_REQUEST,
    SIGNIN_REQUEST_SUCCESS,
    CONFIRM_PASSWORD_CHANGED,
    FORGOT_PASSWORD_REQUEST,
    FORGOT_PASSWORD_REQUEST_SUCCESS,
    COUNTRY_LIST,
    COUNTRY_LIST_SUCCESS,
    PHONE_VERIFICATION_CHANGE,
    PHONE_VERIFICATION_REQUEST,
    PHONE_VERIFICATION_REQUEST_SUCCESS,
    PHONE_VERIFICATION_RESEND_REQUEST,
    PHONE_VERIFICATION_RESEND_REQUEST_SUCCESS,
    LOGOUT_REQUEST,
    SIGNUP_PROFILE,
    SIGNUP_PROFILE_SUCCESS,
    TERMS_CONDITIONS_CHANGE,
    LOGOUT_REQUEST_SUCCESS,
    CHANGE_PASSWORD,
    LOGOUT_REQUEST_FAIL,
} from "../constants/actionTypes";

export const phoneNumberChanged = payload => ({
    type: PHONE_NUMBER_CHANGED,
    payload
});

export const passwordChanged = payload => ({
    type: PASSWORD_CHANGED,
    payload
});

export const confirmPasswordChanged = payload => ({
    type: CONFIRM_PASSWORD_CHANGED,
    payload
});

export const referralCodeChanged = payload => ({
    type: REFERRAL_CODE_CHANGED,
    payload
});

export const countryCodeChanged = payload => ({
    type: COUNTRY_CODE_CHANGED,
    payload
});

// export const getCountryList = () => ({
//     type: COUNTRY_LIST
// });

// export const getCountryListSuccess = payload => ({
//     type: COUNTRY_LIST_SUCCESS,
//     payload
// });

export const signUpRequest = payload => ({
    type: SIGNUP_REQUEST,
    payload
});

export const signUpRequestSuccess = payload => ({
    type: SIGNUP_REQUEST_SUCCESS,
    payload
})

export const signInRequest = payload => ({
    type: SIGNIN_REQUEST,
    payload
});

export const signInRequestSuccess = payload => ({
    type: SIGNIN_REQUEST_SUCCESS,
    payload
});

export const forgotPasswordRequest = payload => ({
    type: FORGOT_PASSWORD_REQUEST,
    payload
});

export const forgotPasswordRequestSuccess = payload => ({
    type: FORGOT_PASSWORD_REQUEST_SUCCESS,
    payload
});

export const phoneVerificationChanged = payload => ({
    type: PHONE_VERIFICATION_CHANGE,
    payload
});

export const phoneVerificationRequest = payload => ({
    type: PHONE_VERIFICATION_REQUEST,
    payload
});

export const phoneVerificationRequestSuccess = payload => ({
    type: PHONE_VERIFICATION_REQUEST_SUCCESS,
    payload
});

export const phoneVerificationResendRequestSuccess = payload => ({
    type: PHONE_VERIFICATION_RESEND_REQUEST_SUCCESS,
    payload
});

export const phoneVerificationResendRequest = payload => ({
    type: PHONE_VERIFICATION_RESEND_REQUEST,
    payload
});

export const logOutRequest = () => ({
    type: LOGOUT_REQUEST
})

export const logOutRequestSuccess = () => ({
    type: LOGOUT_REQUEST_SUCCESS
})

export const logOutRequestFail = () => ({
    type: LOGOUT_REQUEST_FAIL
})

export const SignUpProfile = payload => ({
    type: SIGNUP_PROFILE,
    payload
})

export const SignUpProfileSuccess = () => ({
    type: SIGNUP_PROFILE_SUCCESS
})

export const termsConditionsChange = payload => ({
    type: TERMS_CONDITIONS_CHANGE,
    payload
})

export const changePassword = payload => ({
    type: CHANGE_PASSWORD,
    payload
})

export const resetPhoneAndPass = () => ({
    type: RESET_PHONE_AND_PASSWORD
})

export const userLogout = payload => {
    payload.history.push("/logout");
}